import React from 'react';
import { UserX } from 'lucide-react';
import config from '../../configLoader';
import './InactiveBadge.css';

/**
 * Outlined "Inactive" pill for terminated/inactive employees with pending time
 * (Payroll Timesheet Modifications, M1-B3 — accepted design v2, board shot 01 /
 * drill-down shots 02–03). Outlined and slate on purpose: a FILLED pill on these
 * surfaces means a timesheet status, and inactive-ness must never read as one.
 *
 * Renders nothing when the tenant's `payrollTimesheetEditing` feature is off —
 * absence must degrade to exactly today's UI. Callers still gate on
 * `active === false` themselves (this component has no employee context).
 */
export interface InactiveBadgeProps {
  className?: string;
}

const InactiveBadge: React.FC<InactiveBadgeProps> = ({ className }) => {
  if (config.payrollTimesheetEditing?.enabled !== true) return null;

  return (
    <span
      className={`pe-inactive${className ? ` ${className}` : ''}`}
      title="Inactive employee with pending time — payroll acts here; the employee cannot"
    >
      <UserX />
      Inactive
    </span>
  );
};

export default InactiveBadge;
